import { Swiper } from 'swiper';
import { Thumbs, Navigation, Keyboard } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

export class ModalGalleryMain {
	private element: HTMLElement;
	private readonly modalElement: HTMLElement | null;
	private sliderElement: HTMLElement;
	private buttonPrev: HTMLButtonElement;
	private buttonNext: HTMLButtonElement;
	private readonly thumbs: Swiper;
	private sliderSettings = (): SwiperOptions => ({
		modules: [Thumbs, Navigation, Keyboard],
		slidesPerView: 1,
		navigation: {
			prevEl: this.buttonPrev,
			nextEl: this.buttonNext,
		},
		keyboard: {
			enabled: false,
			onlyInViewport: true,
		},
		thumbs: {
			swiper: this.thumbs,
		},
	} as SwiperOptions);

	public slider: Swiper;

	constructor(element, thumbs) {
		if (!element) return;
		this.element = element;
		this.thumbs = thumbs;
		this.modalElement = this.element.closest('.modal-gallery');

		this.init();
	}

	private handleModalOpen = (): void => {
		this.slider.keyboard.enable();
	};

	private handleModalClose = (): void => {
		this.slider.keyboard.disable();
	};

	public init = ():void => {
		this.sliderElement = this.element.querySelector('.modal-gallery-main__slider');
		this.buttonPrev = this.element.querySelector('.modal-gallery-main__button--prev');
		this.buttonNext = this.element.querySelector('.modal-gallery-main__button--next');
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
		this.modalElement?.addEventListener('modalOpen', this.handleModalOpen);
		this.modalElement?.addEventListener('modalClose', this.handleModalClose);

		if (this.modalElement?.classList.contains('modal-window--active')) {
			this.slider.keyboard.enable();
		}
	};

	public slideTo = (index: number): void => {
		this.slider.slideTo(index, 0);
	};
}
